import { type ComponentProps } from 'react';
import { Root } from '@radix-ui/react-label';

import { cn } from '@/util/utils';

/** The field's name: text-sm medium on the content colour, per the design system's Input. */
function Label({ className, ref, ...props }: ComponentProps<typeof Root>) {
    return (
        <Root
            data-slot="label"
            ref={ref}
            className={cn(
                'text-foreground flex items-center gap-1.5 text-sm leading-5 font-medium select-none',
                'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
                className,
            )}
            {...props}
        />
    );
}

export { Label };
